import type { CreateInmuebleModel, DireccionModel } from '@api/api';
import { TipoInmuebleEnum, TipoObraEnum, TipoCalentadorEnum, TipoCocinaEnum, TipoCalefaccionEnum } from '@api/api';

export class CreateInmueble implements CreateInmuebleModel {
    IdDelegacionInmobiliaria: string | null = null;
    IdAgenteResponsable: string | null = null;
    TipoInmueble: TipoInmuebleEnum = TipoInmuebleEnum.ViviendaUnifamiliar;
    TipoObra: TipoObraEnum = TipoObraEnum.Nueva;
    Direccion: DireccionModel = {
        CodigoPostal: null,
        Provincia: null,
        Municipio: null,
        TipoVia: null,
        NombreVia: null,
        Numero: null,
        Escalera: null,
        Piso: null,
        Puerta: null
    };
    TipoCalentador: TipoCalentadorEnum = TipoCalentadorEnum.Electrico;
    TipoCocina: TipoCocinaEnum = TipoCocinaEnum.Electrica;
    TipoCalefaccion: TipoCalefaccionEnum = TipoCalefaccionEnum.Electrica;
    TieneCalefaccionCentral: boolean = false;
    CapacidadMaxima: number = 0;
    TieneServicioLuz: boolean = false;
    CupsLuz: string | null = null;
    TieneServicioGas: boolean = false;
    CupsGas: string | null = null;
    TieneServicioAgua: boolean = false;

    constructor(data?: Partial<CreateInmueble>) {
        Object.assign(this, data);
    }
} 